// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Funds Withdrawal – Complete / Pending / Cancelled */
.withdrawal-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.withdrawal-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.withdrawal-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.withdrawal-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.withdrawal-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.withdrawal-section__stats {
  display: flex;
  gap: 1.25rem;
}

.withdrawal-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.withdrawal-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

/* Tabs */
.withdrawal-tabs {
  display: flex;
  gap: 0.25rem;
  padding: 0 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.withdrawal-tab {
  padding: 0.85rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text-muted);
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  margin-bottom: -1px;
}

.withdrawal-tab:hover {
  color: #0f766e;
}

.withdrawal-tab--active {
  color: #0f766e;
  border-bottom-color: #0f766e;
}

.withdrawal-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.5rem;
  background: #fff;
  border-bottom: 1px solid var(--border);
}

.withdrawal-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.withdrawal-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 320px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.withdrawal-search-input::placeholder {
  color: var(--text-muted);
}

.withdrawal-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.withdrawal-table-wrap {
  overflow-x: auto;
}

.withdrawal-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.withdrawal-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.withdrawal-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.withdrawal-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.withdrawal-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.withdrawal-table tbody tr:hover {
  background: #f0fdfa !important;
}

.withdrawal-table tbody tr:last-child td {
  border-bottom: none;
}

.withdrawal-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.withdrawal-hash {
  font-family: ui-monospace, monospace;
  font-size: 0.78rem;
  color: #475569;
  cursor: default;
}

.withdrawal-bank-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
  font-family: inherit;
  font-weight: 500;
  color: #0f766e;
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.withdrawal-bank-btn:hover {
  background: #ccfbf1;
}

.withdrawal-bank-btn i {
  font-size: 0.7rem;
}

.withdrawal-payment {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 600;
}

.withdrawal-payment--crypto {
  background: #e0f2fe;
  color: #0369a1;
}

.withdrawal-payment--fiat {
  background: #fef3c7;
  color: #92400e;
}

.withdrawal-status {
  display: inline-block;
  padding: 0.3rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
}

.withdrawal-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.withdrawal-status--completed {
  background: #dcfce7;
  color: #166534;
}

.withdrawal-status--cancelled {
  background: #f1f5f9;
  color: #64748b;
}

.withdrawal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.withdrawal-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.withdrawal-btn--approve {
  background: #dcfce7;
  color: #166534;
}

.withdrawal-btn--approve:hover {
  background: #16a34a;
  color: #fff;
}

.withdrawal-btn--cancel {
  background: #fef2f2;
  color: #b91c1c;
}

.withdrawal-btn--cancel:hover {
  background: #dc2626;
  color: #fff;
}

.withdrawal-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

/* Bank details modal */
.withdrawal-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.withdrawal-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.withdrawal-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.withdrawal-modal__header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
}

.withdrawal-modal__close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  font-size: 1rem;
}

.withdrawal-modal__close:hover {
  background: rgba(255, 255, 255, 0.35);
}

.withdrawal-modal__body {
  padding: 1.25rem 1.5rem;
}

.withdrawal-dl {
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.75rem;
}

.withdrawal-dl div {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 0.5rem;
  align-items: start;
}

.withdrawal-dl dt {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-muted);
}

.withdrawal-dl dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text);
}

.withdrawal-dl dd.withdrawal-mono {
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Funds/FundsWithdrawalPage.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* Funds Withdrawal – Complete / Pending / Cancelled */\n.withdrawal-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.withdrawal-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawal-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.withdrawal-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.withdrawal-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.withdrawal-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.withdrawal-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.withdrawal-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n/* Tabs */\n.withdrawal-tabs {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawal-tab {\n  padding: 0.85rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s;\n  margin-bottom: -1px;\n}\n\n.withdrawal-tab:hover {\n  color: #0f766e;\n}\n\n.withdrawal-tab--active {\n  color: #0f766e;\n  border-bottom-color: #0f766e;\n}\n\n.withdrawal-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.5rem;\n  background: #fff;\n  border-bottom: 1px solid var(--border);\n}\n\n.withdrawal-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.withdrawal-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 320px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.withdrawal-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.withdrawal-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.withdrawal-table-wrap {\n  overflow-x: auto;\n}\n\n.withdrawal-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.withdrawal-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.withdrawal-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.withdrawal-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.withdrawal-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.withdrawal-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.withdrawal-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.withdrawal-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.withdrawal-hash {\n  font-family: ui-monospace, monospace;\n  font-size: 0.78rem;\n  color: #475569;\n  cursor: default;\n}\n\n.withdrawal-bank-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.3rem 0.5rem;\n  font-size: 0.8rem;\n  font-family: inherit;\n  font-weight: 500;\n  color: #0f766e;\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.withdrawal-bank-btn:hover {\n  background: #ccfbf1;\n}\n\n.withdrawal-bank-btn i {\n  font-size: 0.7rem;\n}\n\n.withdrawal-payment {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.withdrawal-payment--crypto {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.withdrawal-payment--fiat {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.withdrawal-status {\n  display: inline-block;\n  padding: 0.3rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.withdrawal-status--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.withdrawal-status--completed {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.withdrawal-status--cancelled {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.withdrawal-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.withdrawal-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.withdrawal-btn--approve {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.withdrawal-btn--approve:hover {\n  background: #16a34a;\n  color: #fff;\n}\n\n.withdrawal-btn--cancel {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.withdrawal-btn--cancel:hover {\n  background: #dc2626;\n  color: #fff;\n}\n\n.withdrawal-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Bank details modal */\n.withdrawal-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.withdrawal-modal {\n  background: #fff;\n  border-radius: 12px;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n}\n\n.withdrawal-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.withdrawal-modal__header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.withdrawal-modal__close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.withdrawal-modal__close:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.withdrawal-modal__body {\n  padding: 1.25rem 1.5rem;\n}\n\n.withdrawal-dl {\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 0.75rem;\n}\n\n.withdrawal-dl div {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 0.5rem;\n  align-items: start;\n}\n\n.withdrawal-dl dt {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.withdrawal-dl dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.withdrawal-dl dd.withdrawal-mono {\n  font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
